(function () {
	'use strict';

	// ─── Hero rotation (Arelis Hero widget) ─────────────────────────────────────
	// Figma: text and artwork change together, every 7.5 s with a 600 ms dissolve
	// (CSS). Pause/play and slide buttons; autoplay pauses while the pointer or
	// focus is inside, and never starts when the visitor prefers reduced motion.
	// Re-adding .is-active restarts the pencil sundial for the launch slide.

	var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function initHero(hero) {
		if (hero.dataset.ready) {
			return;
		}
		hero.dataset.ready = '1';

		var slides = Array.prototype.slice.call(hero.querySelectorAll('.arelis-hero__slide'));
		var dots = Array.prototype.slice.call(hero.querySelectorAll('.arelis-hero__dot'));
		var toggle = hero.querySelector('.arelis-hero__toggle');
		var interval = parseInt(hero.dataset.interval, 10) || 7500;
		var current = 0;
		var timer = null;
		var paused = hero.dataset.autoplay !== 'true' || reducedMotion.matches;
		var hovering = false;

		function show(index) {
			if (index === current || !slides[index]) {
				return;
			}
			var previous = slides[current];
			previous.classList.remove('is-active');
			previous.setAttribute('aria-hidden', 'true');
			previous.setAttribute('inert', '');

			var next = slides[index];
			next.classList.add('is-active');
			next.removeAttribute('aria-hidden');
			next.removeAttribute('inert');

			dots.forEach(function (dot, i) {
				if (i === index) {
					dot.setAttribute('aria-current', 'true');
				} else {
					dot.removeAttribute('aria-current');
				}
			});
			current = index;
		}

		function schedule() {
			window.clearTimeout(timer);
			if (!paused && !hovering && slides.length > 1) {
				timer = window.setTimeout(function () {
					show((current + 1) % slides.length);
					schedule();
				}, interval);
			}
		}

		function setPaused(value) {
			paused = value;
			if (toggle) {
				toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
				toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
			}
			schedule();
		}

		if (toggle) {
			toggle.addEventListener('click', function () {
				setPaused(!paused);
			});
		}

		dots.forEach(function (dot, i) {
			dot.addEventListener('click', function () {
				show(i);
				schedule();
			});
		});

		hero.addEventListener('mouseenter', function () { hovering = true; schedule(); });
		hero.addEventListener('mouseleave', function () { hovering = false; schedule(); });
		hero.addEventListener('focusin', function () { hovering = true; schedule(); });
		hero.addEventListener('focusout', function (event) {
			if (!hero.contains(event.relatedTarget)) {
				hovering = false;
				schedule();
			}
		});

		document.addEventListener('visibilitychange', schedule);
		setPaused(paused);
	}

	function initAll(scope) {
		Array.prototype.forEach.call((scope || document).querySelectorAll('.arelis-hero'), initHero);
	}

	document.addEventListener('DOMContentLoaded', function () {
		initAll();
	});

	// Elementor editor: widgets re-render, so initialise again on each render.
	window.addEventListener('elementor/frontend/init', function () {
		window.elementorFrontend.hooks.addAction('frontend/element_ready/arelis_hero.default', function ($scope) {
			initAll($scope[0]);
		});
	});

})();
